import api from "../../../../../api/axios"
// import { Axios } from "../../../../../../../legacyComponents/util"

export default async function getDependent(dependentId) {
	try {
		const url = `dependent/${dependentId}`
		const response = await api.get(url)

		return response?.data
	} catch (error) {
		console.error(error)
	}
}
